module.exports = __webpack_public_path__ + "static/img/bigWheel4.17a5bce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bigWheel4.png
// module id = dJh1
// module chunks = 2